export default __webpack_public_path__ + "static/media/kumaraswamy_family.701ed8b7.jpg";